export const formatPeriodLabel = period => {
  if (!period) return '';
  const name = String(period.period ?? '');
  const year = String(period.year ?? '');
  return year && !name.includes(year) ? `${name} ${year}`.trim() : name;
};
